import Link from "next/link";
import { Heart, Globe, BookOpen, TrendingUp, Users, Star } from "lucide-react";

const services = [
  {
    icon: Heart,
    color: "#0047AB",
    bg: "#EFF6FF",
    title: "Мэдлэг дээшлүүлэх",
    description: "Чих хамар хоолой, толгой хүзүүний мэс заслын салбарт ажилладаг эмч, судлаач нарын хоорондын уялдаа холбоог сайжруулан мэдлэг мэргэжлийг байнга дээшлүүлэх.",
  },
  {
    icon: Globe,
    color: "#0076A3",
    bg: "#E0F7FA",
    title: "Олон улсын хамтын ажиллагаа",
    description: "Олон улсын болон дотоодын байгууллагуудтай хамтран ажиллах, олон улсын хурал зөвлөгөөнд оролцох болон өөрийн оронд зохион байгуулах.",
  },
  {
    icon: BookOpen,
    color: "#00B4D8",
    bg: "#E0F7FF",
    title: "Сургалт & Семинар",
    description: "Эмч нарт орчин үеийн ололт амжилт, ёс зүйн талаарх мэдээллийг түгээх, дадлага, мэдлэгийг нэмэгдүүлэх сургалт, семинар зохион байгуулах.",
  },
  {
    icon: TrendingUp,
    color: "#6366F1",
    bg: "#EEF2FF",
    title: "Мэргэжлийн зэрэг",
    description: "Эмч нарын мэргэжлийн зэрэг ахиулах, дээшлүүлэх арга хэмжээг зохион байгуулахад холбогдох байгууллагуудтай хамтран ажиллана.",
  },
  {
    icon: Star,
    color: "#F4A40A",
    bg: "#FFFBEB",
    title: "Шагнал & Урамшуулал",
    description: "Эмч нарыг дүгнэн мэргэжлийн бүтээмж, ур чадварыг үнэлэн шагнан урамшуулах.",
  },
  {
    icon: Users,
    color: "#10B981",
    bg: "#ECFDF5",
    title: "Гишүүнчлэл",
    description: "Монгол улсад чих хамар хоолойн чиглэлээр үйл ажиллагаа явуулж буй эмч, мэргэжилтнүүдэд нийгэмлэгийн гишүүнээр элсэх боломж нээлттэй.",
  },
];

const SectionLabel = ({ children }) => (
  <div style={{
    display: "inline-flex", alignItems: "center", gap: 8,
    background: "#EFF6FF", borderRadius: 100,
    padding: "6px 16px", marginBottom: 16,
  }}>
    <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#0047AB" }} />
    <span style={{ fontSize: 13, fontWeight: 600, color: "#0047AB", letterSpacing: "0.04em", textTransform: "uppercase" }}>
      {children}
    </span>
  </div>
);

export default function ServicesSection() {
  return (
    <section style={{ background: "#F8FAFC", padding: "96px 0" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px" }}>

        {/* Section header */}
        <div style={{ textAlign: "center", marginBottom: 64 }} className="animate-fade-up">
          <SectionLabel>Үйл ажиллагаа</SectionLabel>
          <h2 style={{
            fontSize: "clamp(1.8rem, 3vw, 2.6rem)",
            fontWeight: 800,
            color: "#0A0F1E",
            lineHeight: 1.2,
            marginBottom: 16,
            fontFamily: "'Outfit', 'Inter', sans-serif",
          }}>
            Нийгэмлэгийн үндсэн{" "}
            <span style={{
              background: "linear-gradient(135deg, #0047AB 0%, #00B4D8 100%)",
              WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text",
            }}>
              чиглэл
            </span>
          </h2>
          <p style={{ fontSize: 17, color: "#64748B", maxWidth: 560, margin: "0 auto", lineHeight: 1.7 }}>
            Монголын чих хамар хоолойн эмч нарын мэргэжлийг дэмжих, хөгжүүлэхэд чиглэсэн үйл ажиллагаанууд
          </p>
        </div>

        {/* Services grid */}
        <div className="stagger" style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: 24,
          marginBottom: 64,
        }}>
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                className="animate-fade-up card"
                style={{
                  padding: "28px 28px 24px",
                  display: "flex", flexDirection: "column", gap: 14,
                }}
              >
                <div style={{
                  width: 48, height: 48,
                  background: s.bg,
                  borderRadius: 12,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>
                  <Icon size={22} color={s.color} />
                </div>
                <div>
                  <h3 style={{ fontSize: 16, fontWeight: 700, color: "#0A0F1E", marginBottom: 8 }}>{s.title}</h3>
                  <p style={{ fontSize: 14, color: "#64748B", lineHeight: 1.7 }}>{s.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* About block */}
        <div style={{
          background: "linear-gradient(135deg, #001845 0%, #0047AB 50%, #0076A3 100%)",
          borderRadius: 24,
          padding: "48px 56px",
          position: "relative",
          overflow: "hidden",
        }}>
          {/* bg decoration */}
          <div style={{
            position: "absolute", top: -60, right: -60,
            width: 300, height: 300,
            background: "radial-gradient(circle, rgba(0,180,216,0.2) 0%, transparent 70%)",
            borderRadius: "50%",
          }} />
          <div style={{
            position: "absolute", bottom: -40, left: -40,
            width: 200, height: 200,
            background: "radial-gradient(circle, rgba(244,164,10,0.15) 0%, transparent 70%)",
            borderRadius: "50%",
          }} />
          <div style={{ position: "relative", zIndex: 1 }}>
            <div style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 100, padding: "5px 14px", marginBottom: 20,
            }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: "rgba(255,255,255,0.85)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                Нийгэмлэгийн тухай
              </span>
            </div>
            <h3 style={{
              fontSize: "clamp(1.4rem, 2.5vw, 2rem)",
              fontWeight: 800, color: "#ffffff",
              marginBottom: 20, fontFamily: "'Outfit', sans-serif",
              maxWidth: 700,
            }}>
              Нийтлэг үндэслэл
            </h3>
            <p style={{
              fontSize: 15, color: "rgba(255,255,255,0.75)",
              lineHeight: 1.85, maxWidth: 800,
            }}>
              Монголын Чих Хамар Хоолойн Эмч Нарын Нийгэмлэг нь чих хамар хоолойн эмч нар болон мэргэжилтнүүдийг сайн дурын үндсэн дээр нэгтгэсэн, Монгол Улсын Үндсэн Хууль, Төрийн бус байгууллагын тухай хууль, бусад хууль тогтоомжийн хүрээнд нийгэмд үйлчилдэг, өөрийгөө удирдах зарчмаар үйл ажиллагаа явуулдаг ашгийн бус, төрийн бус байгууллага болно. Нийгэмлэг нь улсын бүртгэлд бүртгэгдсэн бие даасан хуулийн этгээд бөгөөд нийгэмлэгийн эмблем, тамга, харилцах данстай байна.
            </p>
            <div style={{ marginTop: 28, display: "flex", gap: 12, flexWrap: "wrap" }}>
              <div style={{
                background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 10, padding: "8px 18px",
                fontSize: 13, fontWeight: 600, color: "rgba(255,255,255,0.9)",
              }}>
                📅 Үүсгэн байгуулагдсан: 1967 он
              </div>
              <Link href="/about">
                <button style={{
                  background: "#ffffff", color: "#0047AB",
                  border: "none", borderRadius: 10,
                  padding: "8px 20px", fontSize: 13, fontWeight: 700,
                  cursor: "pointer", display: "flex", alignItems: "center", gap: 6,
                  transition: "opacity 0.2s",
                }}
                  onMouseEnter={e => e.currentTarget.style.opacity = "0.9"}
                  onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                >
                  Дэлгэрэнгүй →
                </button>
              </Link>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
